import { SearchIcon } from '@icons/IconLibrary';
import { UIDiv, UIInput } from '@ui';

export default class Search extends UIDiv {
  constructor({
    handleSearch = () => {},
    placeholder = i18next.t('common.search'),
    className = '',
    inputId = 'search-input',
  }) {
    super();
    this.handleSearch = handleSearch;
    this.placeholder = placeholder;
    this.inputId = inputId;
    this.setClass('relative h-10');
    if (className) {
      this.addClass(className);
    }
    this.#render();
  }

  #render() {
    const searchIcon = new SearchIcon({
      color: 'none',
      strokeColor: '#787777',
    });
    searchIcon.setClass(
      'absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-500',
    );
    this.searchInput = new UIInput('');
    this.searchInput.setId(this.inputId);
    this.searchInput.setClass(
      'w-full pl-10 pr-3 cursor-text py-2 bg-[#F2F5F9] border-0 rounded-xl !shadow-none focus:outline-none focus:bg-white placeholder-[#787777] focus:ring-2 focus:ring-[var(--o-hive-primary-80)]',
    );
    this.searchInput.setPlaceholder(this.placeholder);
    this.searchInput.onInput(e => {
      this.searchQuery = e.target.value;
      this.handleSearch(this.searchQuery);
    });

    this.add(searchIcon);
    this.add(this.searchInput);
  }
}
